import { render, staticRenderFns } from "./ChallengePartner.vue?vue&type=template&id=2196efec&scoped=true&"
import script from "./ChallengePartner.vue?vue&type=script&lang=js&"
export * from "./ChallengePartner.vue?vue&type=script&lang=js&"
import style0 from "./ChallengePartner.vue?vue&type=style&index=0&id=2196efec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196efec",
  null
  
)

export default component.exports